<template>
	<div class="col-sm-12 col-md-10 col-lg-10 p-3">
    <UplimitReason @show_sidebar="show_sidebar"></UplimitReason>
    <StockInfoSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" :date_mark="date_mark"></StockInfoSidebar>

	</div>
</template>

<script>
	import UplimitReason from 'components/uplimit/UplimitReason.vue'
	import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'

	export default {
        data() {
            return {
                isActive: true,
                symbol_code: '603069',
                symbol_name: '',
                date_mark: ''
            }
        },
		components: {
			UplimitReason,
			StockInfoSidebar
		},
		methods: {
            show_sidebar(stock_info) {
                this.symbol_code = stock_info['stock_code'];
                this.symbol_name = stock_info['stock_name'];
                this.date_mark = stock_info['date1'] || ''
            }
		}
	}
</script>

<style>
</style>
